const {
  getSession,
  createSession,
  sendSessionEvent,
  updateSession,
} = require('@ropto/client-library');

exports.onClientEntry = (_, { baseUrl, enablePosts, pageDetails }) => {
  const sessionName = `${pageDetails.pageName}${pageDetails.pageVariant}Session`;
  window.roptoSession = {
    createSession: (sessionData) => {
      createSession({
        ...sessionData,
        baseUrl: enablePosts ? baseUrl : null,
        sessionName
      });
    },
    sendSessionEvent: (sessionEventData) => {
      sendSessionEvent({
        ...sessionEventData,
        baseUrl: enablePosts ? baseUrl : null,
        sessionName
      });
    },
    updateSession: (newSessiondata) => {
      updateSession({
        baseUrl: enablePosts ? baseUrl : null,
        sessionName,
        ...newSessiondata,
      })
    },
    getSession: () => getSession(sessionName)
  }
}

exports.wrapPageElement = ({ element, props }, pluginOptions) => {
  window.roptoSession.createSession({ location: props.location, siteData: { pageDetails: pluginOptions.pageDetails } })
  return element;
}

exports.onRouteUpdate = ({ location }) => {
  let { pathname } = location;
  let prefix = process.env.SITE_PREFIX || '/';

  prefix = prefix.replace(/\/$/, '');
  pathname = pathname.replace(prefix, '');

  window.roptoSession.sendSessionEvent({
    action: 'PAGE_VIEW',
    value: pathname,
  });
}
